/**
 * Add query parameter to given url.
 */
export const addQueryParamToUrl = (url: string, paramKey: string, paramValue: string): string => {
  const urlObject = createURLObject(url);

  if (!urlObject.searchParams.has(paramKey)) {
    urlObject.searchParams.append(paramKey, paramValue);
  }

  return urlObject.toString();
};

const createURLObject = (url: string): URL => {
  // second argument is here to allow creating object from relative urls
  return new URL(url, process.env.NEXT_PUBLIC_DOMAIN_URL);
};
